var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.resources,"size":"small","loading":_vm.loading,"highlight-row":"","stripe":"","max-height":"700","show-summary":true,"summary-method":_vm.handleSummary},scopedSlots:_vm._u([{key:"amount",fn:function(ref){
var row = ref.row;
return [_c('b',[_vm._v("\n        "+_vm._s(_vm.formatCurrency(row.amount ? row.amount : 0))+"\n      ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }